import { CmsConfiguration, EnvironmentMap, EnvironmentName } from 'cms/cms.config';
import { RenderConfiguration } from 'render/render.config';

import { environment as desCMSEnv, renderEnvironment as desRenderEnv } from './environment.oy.des';
import { environment as localCMSEnv, renderEnvironment as localRenderEnv } from './environment.oy.local';
import { environment as preCMSEnv, renderEnvironment as preRenderEnv } from './environment.oy.pre';
import { environment as proCMSEnv, renderEnvironment as proRenderEnv } from './environment.oy.pro';
import { getEnvironmentFromHost } from './get-environment-from-host';


export const cmsEnvironments: EnvironmentMap = {
  LOCAL: {
    cms: localCMSEnv,
    render: localRenderEnv
  },
  DES: {
    cms: desCMSEnv,
    render: desRenderEnv
  },
  PRE: {
    cms: preCMSEnv,
    render: preRenderEnv
  },
  PRO: {
    cms: proCMSEnv,
    render: proRenderEnv
  }
};

const envName = getEnvironmentFromHost() as EnvironmentName;


export const {
  cms: environment,
  render: renderEnvironment
}: { cms: CmsConfiguration; render: RenderConfiguration } = cmsEnvironments[envName];

